import type { ReactNode } from 'react';
import styles from './Toolbar.module.css';

export const Toolbar = ({ children, label }: { children: ReactNode; label?: string | undefined }) => (
  <div className={styles['toolbar']} role={label === undefined ? undefined : 'toolbar'} aria-label={label}>
    {children}
  </div>
);

export const ToolbarSpacer = () => <span className={styles['spacer']} aria-hidden="true" />;
